module.exports = __webpack_public_path__ + "img/lf2.a2810791.png";